/** Contact card: Email, Phone, Address. Pencil opens the contact edit face. */
import type { ShopSummary } from '../../api/types.ts';
import { DetailRow } from './DetailRow.tsx';
import { EditableCard } from './EditableCard.tsx';

export interface ShopContactCardProps {
  shop: ShopSummary;
  canWrite: boolean;
  onSaved: () => void;
}

export function ShopContactCard({ shop, canWrite, onSaved }: Readonly<ShopContactCardProps>): React.JSX.Element {
  return (
    <EditableCard title="Contact" group="contact" shop={shop} canWrite={canWrite} onSaved={onSaved}>
      <DetailRow label="Email" value={shop.email ?? '-'} />
      <DetailRow label="Phone" value={shop.phone ?? '-'} />
      <DetailRow label="Address" value={shop.address ?? '-'} />
    </EditableCard>
  );
}

export default ShopContactCard;
